import { config } from 'affiny-core/env';
import { OnPageChange } from 'affiny-desktop/src/components/OnPageChange';
import { Fallback } from 'affiny-ui/src';
import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { AnalyticsInfoUser } from '../components/desktop/AnalyticsInfoUser';
import { Layer } from '../components/desktop/layer/Layer';
import { Layout } from '../components/desktop/Layout';

import pages from './pages';

const Routes = () => (
  <Router basename={config.env.publicBasePath}>
    <AnalyticsInfoUser>
      <OnPageChange>
        <Layout>
          <Suspense fallback={<Fallback delay={1000} />}>
            <Switch>
              {pages.map(({ path, Component, params }) => (
                <Route key={path} path={path} {...params}>
                  <Component />
                </Route>
              ))}
            </Switch>
          </Suspense>
        </Layout>
      </OnPageChange>
    </AnalyticsInfoUser>
    <Layer />
  </Router>
);

export default Routes;
